module.exports = __webpack_public_path__ + "static/media/new_file.fb8e83d5.svg";